import { IThemeConfigOverrides } from './theme';
import { THEMES } from '@cmctechnology/webinvest-constants';
import { themeSetUp } from './themeUtils';

const themeConfigOverrides: IThemeConfigOverrides = {
  logos: {
    header: {
      color: `/l/westpac/primary.svg`,
      white: `/l/westpac/white.svg`
    },
    mark: {
      color: `/l/westpac/32x32-color.svg`,
      black: `/l/westpac/32x32-black.svg`,
      white: `/l/westpac/32x32-white.svg`
    },
    footer: {
      color: `/l/westpac/primary.svg`,
      white: `/l/westpac/white.svg`
    },
    whiteLabel: {
      color: `/l/westpac/color.svg`,
      black: `/l/westpac/black.svg`,
      white: `/l/westpac/white.svg`
    }
  }
};

const componentOverrides = {};
export const westpacTheme = themeSetUp(THEMES.Westpac, false, themeConfigOverrides, componentOverrides);
export const westpacDarkTheme = themeSetUp(THEMES.Westpac, true, themeConfigOverrides, componentOverrides);
